import React, { FC } from 'react';
import s from './desktopView.scss';
import { desktopViewDataHooks } from './DesktopView.dataHooks';
import { buildIframeUrl } from '../../../utils/urlBuilders';

interface Props {
  dataHook?: string;
  url: string;
  title: string;
}

export const DesktopView: FC<Props> = ({ url, title, dataHook }) => {
  const iframeUrl = buildIframeUrl(url);

  return (
    <div data-hook={dataHook} className={s.display}>
      <iframe
        data-hook={desktopViewDataHooks.desktopIframe}
        src={iframeUrl}
        title={title}
        width="100%"
        height="100%"
        className={s.iframe}
      />
    </div>
  );
};
